import { render, staticRenderFns } from "./EscalasFisiatricas.vue?vue&type=template&id=3f0269f4"
import script from "./EscalasFisiatricas.vue?vue&type=script&lang=js"
export * from "./EscalasFisiatricas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports